export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';
export const ETH_ADDRESS = ZERO_ADDRESS;
export const GENERAL_INSTANCE = class {
};
export const DEFAULT_NETWORK_ID = 690;
export const DEFAULT_DECIMAL = 18;
export const DEFAULT_REFERRAL_ADDRESS = '0xdfaf5940F87b1d79A783b15a7e8e444123Cf12FC';
export const BITLY_API_URL = 'https://api.bitly.exchange';
export const PAIR_MARGIN = 100;
